// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 全局暗黑主题样式 */
body {
  background: #0d1117 !important;
  color: #e6edf3 !important;
  font-family: -apple-system, 'PingFang SC', 'Microsoft YaHei', sans-serif !important;
}

/* Ant Design 组件暗黑主题覆盖 */
.ant-layout {
  background: #0d1117 !important;
}

.ant-layout-header {
  background: #161b22 !important;
  border-bottom: 1px solid #30363d !important;
}

.ant-layout-content {
  background: #0d1117 !important;
}

.ant-card {
  background: #161b22 !important;
  border: 1px solid #30363d !important;
  color: #e6edf3 !important;
}

.ant-card-head {
  background: #161b22 !important;
  border-bottom: 1px solid #30363d !important;
  color: #e6edf3 !important;
}

.ant-card-head-title {
  color: #e6edf3 !important;
}

.ant-card-body {
  background: #161b22 !important;
  color: #e6edf3 !important;
}

.ant-btn {
  background: #21262d !important;
  border: 1px solid #30363d !important;
  color: #e6edf3 !important;
}

.ant-btn:hover {
  background: #30363d !important;
  color: #e6edf3 !important;
}

.ant-btn-primary {
  background: #238636 !important;
  border: 1px solid #238636 !important;
  color: #fff !important;
}

.ant-btn-primary:hover {
  background: #2ea043 !important;
  border: 1px solid #2ea043 !important;
}

.ant-btn-text {
  background: transparent !important;
  color: #e6edf3 !important;
}

.ant-btn-text:hover {
  background: #21262d !important;
  color: #e6edf3 !important;
}

.ant-table {
  background: #161b22 !important;
  color: #e6edf3 !important;
}

.ant-table-thead > tr > th {
  background: #21262d !important;
  color: #8b949e !important;
  border-bottom: 1px solid #30363d !important;
}

.ant-table-tbody > tr > td {
  background: #161b22 !important;
  color: #e6edf3 !important;
  border-bottom: 1px solid #21262d !important;
}

.ant-table-tbody > tr:hover > td {
  background: #1c2128 !important;
}

.ant-table-tbody > tr:nth-child(odd) > td {
  background: #0d1117 !important;
}

.ant-select {
  background: #21262d !important;
  border: 1px solid #30363d !important;
  color: #e6edf3 !important;
}

.ant-select-selector {
  background: #21262d !important;
  border: 1px solid #30363d !important;
  color: #e6edf3 !important;
}

.ant-select-dropdown {
  background: #21262d !important;
  border: 1px solid #30363d !important;
}

.ant-select-item {
  color: #e6edf3 !important;
}

.ant-select-item-option-active {
  background: #30363d !important;
}

.ant-select-item-option-selected {
  background: #238636 !important;
  color: #fff !important;
}

.ant-input {
  background: #21262d !important;
  border: 1px solid #30363d !important;
  color: #e6edf3 !important;
}

.ant-input:hover {
  border-color: #58a6ff !important;
}

.ant-input:focus {
  border-color: #58a6ff !important;
  box-shadow: 0 0 0 2px rgba(88, 166, 255, 0.2) !important;
}

.ant-modal {
  background: #161b22 !important;
}

.ant-modal-header {
  background: #161b22 !important;
  border-bottom: 1px solid #30363d !important;
}

.ant-modal-title {
  color: #ffffff !important;
}

.ant-modal-content {
  background: #161b22 !important;
  color: #ffffff !important;
}

.ant-modal-body {
  background: #161b22 !important;
  color: #ffffff !important;
}

/* 强制覆盖 Modal 文字颜色 */
.ant-modal-confirm-content {
  color: #ffffff !important;
}

.ant-modal-confirm-title {
  color: #ffffff !important;
}

.ant-modal-confirm-body {
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-body {
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-title {
  color: #ffffff !important;
}

/* 使用更高优先级的选择器 */
div.ant-modal-confirm-content {
  color: #ffffff !important;
}

div.ant-modal-confirm-title {
  color: #ffffff !important;
}

.ant-form-item-label > label {
  color: #e6edf3 !important;
}

.ant-form-item-explain-error {
  color: #f85149 !important;
}

.ant-tree {
  background: #161b22 !important;
  color: #e6edf3 !important;
}

.ant-tree-node-content-wrapper {
  color: #e6edf3 !important;
}

.ant-tree-node-content-wrapper:hover {
  background: #30363d !important;
}

.ant-tree-node-selected {
  background: #238636 !important;
}

.ant-tree-node-selected .ant-tree-node-content-wrapper {
  color: #fff !important;
}

.ant-tree-switcher {
  color: #8b949e !important;
}

.ant-dropdown-menu {
  background: #21262d !important;
  border: 1px solid #30363d !important;
}

.ant-dropdown-menu-item {
  color: #e6edf3 !important;
}

.ant-dropdown-menu-item:hover {
  background: #30363d !important;
}

.ant-alert {
  background: #161b22 !important;
  border: 1px solid #30363d !important;
}

.ant-alert-message {
  color: #e6edf3 !important;
}

.ant-alert-description {
  color: #e6edf3 !important;
}

.ant-spin-container {
  background: #161b22 !important;
}

.ant-typography {
  color: #e6edf3 !important;
}

.ant-typography h1,
.ant-typography h2,
.ant-typography h3,
.ant-typography h4,
.ant-typography h5,
.ant-typography h6 {
  color: #e6edf3 !important;
}

.ant-typography p {
  color: #e6edf3 !important;
}

/* 自定义滚动条 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #21262d;
}

::-webkit-scrollbar-thumb {
  background: #30363d;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #484f58;
}

/* 登录页面输入框暗黑样式 */
.dark-input {
  background: #21262d !important;
  border: 1px solid #30363d !important;
  color: #e6edf3 !important;
}

.dark-input:hover,
.dark-input:focus {
  background: #21262d !important;
  border: 1px solid #58a6ff !important;
  color: #e6edf3 !important;
}

.dark-input::placeholder,
.dark-input::-webkit-input-placeholder,
.dark-input::-moz-placeholder {
  color: #ffffff !important;
  opacity: 1 !important;
}

.dark-input.ant-input::placeholder,
.dark-input.ant-input::-webkit-input-placeholder,
.dark-input.ant-input::-moz-placeholder {
  color: #ffffff !important;
  opacity: 1 !important;
}

.ant-input-affix-wrapper::placeholder,
.ant-input-affix-wrapper::-webkit-input-placeholder,
.ant-input-affix-wrapper::-moz-placeholder {
  color: #ffffff !important;
  opacity: 1 !important;
}

.ant-input-affix-wrapper input::placeholder,
.ant-input-affix-wrapper input::-webkit-input-placeholder,
.ant-input-affix-wrapper input::-moz-placeholder {
  color: #ffffff !important;
  opacity: 1 !important;
}

.dark-form .ant-input::placeholder,
.dark-form .ant-input::-webkit-input-placeholder,
.dark-form .ant-input::-moz-placeholder {
  color: #ffffff !important;
  opacity: 1 !important;
}

.dark-form .ant-input-affix-wrapper::placeholder,
.dark-form .ant-input-affix-wrapper::-webkit-input-placeholder,
.dark-form .ant-input-affix-wrapper::-moz-placeholder {
  color: #ffffff !important;
  opacity: 1 !important;
}

.dark-form .ant-input-affix-wrapper input::placeholder,
.dark-form .ant-input-affix-wrapper input::-webkit-input-placeholder,
.dark-form .ant-input-affix-wrapper input::-moz-placeholder {
  color: #ffffff !important;
  opacity: 1 !important;
}

/* Modal 对话框暗黑主题 */
.ant-modal {
  background: #161b22 !important;
}

.ant-modal-header {
  background: #161b22 !important;
  border-bottom: 1px solid #30363d !important;
}

.ant-modal-title {
  color: #ffffff !important;
}

.ant-modal-content {
  background: #161b22 !important;
  color: #ffffff !important;
}

.ant-modal-body {
  background: #161b22 !important;
  color: #ffffff !important;
}

/* 强制覆盖 Modal 文字颜色 */
.ant-modal-confirm-content {
  color: #ffffff !important;
}

.ant-modal-confirm-title {
  color: #ffffff !important;
}

.ant-modal-confirm-body {
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-body {
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-title {
  color: #ffffff !important;
}

/* 使用更高优先级的选择器 */
div.ant-modal-confirm-content {
  color: #ffffff !important;
}

div.ant-modal-confirm-title {
  color: #ffffff !important;
}

.ant-modal-footer {
  background: #161b22 !important;
  border-top: 1px solid #30363d !important;
}

.ant-modal-confirm-btns .ant-btn {
  background: #21262d !important;
  border: 1px solid #30363d !important;
  color: #e6edf3 !important;
}

.ant-modal-confirm-btns .ant-btn:hover {
  background: #30363d !important;
  border: 1px solid #58a6ff !important;
  color: #e6edf3 !important;
}

.ant-modal-confirm-btns .ant-btn-danger {
  background: #da3633 !important;
  border: 1px solid #da3633 !important;
  color: #ffffff !important;
}

.ant-modal-confirm-btns .ant-btn-danger:hover {
  background: #f85149 !important;
  border: 1px solid #f85149 !important;
  color: #ffffff !important;
}

.dark-input.ant-input {
  background: #21262d !important;
  border: 1px solid #30363d !important;
  color: #e6edf3 !important;
}

.dark-input.ant-input:hover,
.dark-input.ant-input:focus {
  background: #21262d !important;
  border: 1px solid #58a6ff !important;
  color: #e6edf3 !important;
}

/* 管理员登录页面特定样式 */
.ant-form-item-control-input .dark-input {
  background: #21262d !important;
  border: 1px solid #30363d !important;
  color: #e6edf3 !important;
}

.ant-input-affix-wrapper {
  background: #21262d !important;
  border: 1px solid #30363d !important;
}

.ant-input-affix-wrapper:hover,
.ant-input-affix-wrapper:focus {
  background: #21262d !important;
  border: 1px solid #58a6ff !important;
}

.ant-input-affix-wrapper input {
  background: #21262d !important;
  color: #e6edf3 !important;
}

.ant-input-affix-wrapper .ant-input {
  background: #21262d !important;
  color: #e6edf3 !important;
}

/* 管理员登录页面强制样式 */
.dark-form .ant-input-affix-wrapper {
  background: #21262d !important;
  border: 1px solid #30363d !important;
}

.dark-form .ant-input-affix-wrapper:hover,
.dark-form .ant-input-affix-wrapper:focus,
.dark-form .ant-input-affix-wrapper-focused {
  background: #21262d !important;
  border: 1px solid #58a6ff !important;
  box-shadow: none !important;
}

.dark-form .ant-input {
  background: #21262d !important;
  color: #e6edf3 !important;
}

.dark-form .ant-input:hover,
.dark-form .ant-input:focus {
  background: #21262d !important;
  color: #e6edf3 !important;
}

.dark-form .ant-input-password input {
  background: #21262d !important;
  color: #e6edf3 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/dark-theme.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mFAAmF;AACrF;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;;;EAGE,8BAA8B;EAC9B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B","sourcesContent":["/* 全局暗黑主题样式 */\r\nbody {\r\n  background: #0d1117 !important;\r\n  color: #e6edf3 !important;\r\n  font-family: -apple-system, 'PingFang SC', 'Microsoft YaHei', sans-serif !important;\r\n}\r\n\r\n/* Ant Design 组件暗黑主题覆盖 */\r\n.ant-layout {\r\n  background: #0d1117 !important;\r\n}\r\n\r\n.ant-layout-header {\r\n  background: #161b22 !important;\r\n  border-bottom: 1px solid #30363d !important;\r\n}\r\n\r\n.ant-layout-content {\r\n  background: #0d1117 !important;\r\n}\r\n\r\n.ant-card {\r\n  background: #161b22 !important;\r\n  border: 1px solid #30363d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-card-head {\r\n  background: #161b22 !important;\r\n  border-bottom: 1px solid #30363d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-card-head-title {\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-card-body {\r\n  background: #161b22 !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-btn {\r\n  background: #21262d !important;\r\n  border: 1px solid #30363d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-btn:hover {\r\n  background: #30363d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-btn-primary {\r\n  background: #238636 !important;\r\n  border: 1px solid #238636 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.ant-btn-primary:hover {\r\n  background: #2ea043 !important;\r\n  border: 1px solid #2ea043 !important;\r\n}\r\n\r\n.ant-btn-text {\r\n  background: transparent !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-btn-text:hover {\r\n  background: #21262d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-table {\r\n  background: #161b22 !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-table-thead > tr > th {\r\n  background: #21262d !important;\r\n  color: #8b949e !important;\r\n  border-bottom: 1px solid #30363d !important;\r\n}\r\n\r\n.ant-table-tbody > tr > td {\r\n  background: #161b22 !important;\r\n  color: #e6edf3 !important;\r\n  border-bottom: 1px solid #21262d !important;\r\n}\r\n\r\n.ant-table-tbody > tr:hover > td {\r\n  background: #1c2128 !important;\r\n}\r\n\r\n.ant-table-tbody > tr:nth-child(odd) > td {\r\n  background: #0d1117 !important;\r\n}\r\n\r\n.ant-select {\r\n  background: #21262d !important;\r\n  border: 1px solid #30363d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-select-selector {\r\n  background: #21262d !important;\r\n  border: 1px solid #30363d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-select-dropdown {\r\n  background: #21262d !important;\r\n  border: 1px solid #30363d !important;\r\n}\r\n\r\n.ant-select-item {\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-select-item-option-active {\r\n  background: #30363d !important;\r\n}\r\n\r\n.ant-select-item-option-selected {\r\n  background: #238636 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.ant-input {\r\n  background: #21262d !important;\r\n  border: 1px solid #30363d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-input:hover {\r\n  border-color: #58a6ff !important;\r\n}\r\n\r\n.ant-input:focus {\r\n  border-color: #58a6ff !important;\r\n  box-shadow: 0 0 0 2px rgba(88, 166, 255, 0.2) !important;\r\n}\r\n\r\n.ant-modal {\r\n  background: #161b22 !important;\r\n}\r\n\r\n.ant-modal-header {\r\n  background: #161b22 !important;\r\n  border-bottom: 1px solid #30363d !important;\r\n}\r\n\r\n.ant-modal-title {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-modal-content {\r\n  background: #161b22 !important;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-modal-body {\r\n  background: #161b22 !important;\r\n  color: #ffffff !important;\r\n}\r\n\r\n/* 强制覆盖 Modal 文字颜色 */\r\n.ant-modal-confirm-content {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-modal-confirm-title {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-modal-confirm-body {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-modal-confirm .ant-modal-body {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-modal-confirm .ant-modal-title {\r\n  color: #ffffff !important;\r\n}\r\n\r\n/* 使用更高优先级的选择器 */\r\ndiv.ant-modal-confirm-content {\r\n  color: #ffffff !important;\r\n}\r\n\r\ndiv.ant-modal-confirm-title {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-form-item-label > label {\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-form-item-explain-error {\r\n  color: #f85149 !important;\r\n}\r\n\r\n.ant-tree {\r\n  background: #161b22 !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-tree-node-content-wrapper {\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-tree-node-content-wrapper:hover {\r\n  background: #30363d !important;\r\n}\r\n\r\n.ant-tree-node-selected {\r\n  background: #238636 !important;\r\n}\r\n\r\n.ant-tree-node-selected .ant-tree-node-content-wrapper {\r\n  color: #fff !important;\r\n}\r\n\r\n.ant-tree-switcher {\r\n  color: #8b949e !important;\r\n}\r\n\r\n.ant-dropdown-menu {\r\n  background: #21262d !important;\r\n  border: 1px solid #30363d !important;\r\n}\r\n\r\n.ant-dropdown-menu-item {\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-dropdown-menu-item:hover {\r\n  background: #30363d !important;\r\n}\r\n\r\n.ant-alert {\r\n  background: #161b22 !important;\r\n  border: 1px solid #30363d !important;\r\n}\r\n\r\n.ant-alert-message {\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-alert-description {\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-spin-container {\r\n  background: #161b22 !important;\r\n}\r\n\r\n.ant-typography {\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-typography h1,\r\n.ant-typography h2,\r\n.ant-typography h3,\r\n.ant-typography h4,\r\n.ant-typography h5,\r\n.ant-typography h6 {\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-typography p {\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n/* 自定义滚动条 */\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: #21262d;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #30363d;\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #484f58;\r\n}\r\n\r\n/* 登录页面输入框暗黑样式 */\r\n.dark-input {\r\n  background: #21262d !important;\r\n  border: 1px solid #30363d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.dark-input:hover,\r\n.dark-input:focus {\r\n  background: #21262d !important;\r\n  border: 1px solid #58a6ff !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.dark-input::placeholder,\r\n.dark-input::-webkit-input-placeholder,\r\n.dark-input::-moz-placeholder {\r\n  color: #ffffff !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.dark-input.ant-input::placeholder,\r\n.dark-input.ant-input::-webkit-input-placeholder,\r\n.dark-input.ant-input::-moz-placeholder {\r\n  color: #ffffff !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.ant-input-affix-wrapper::placeholder,\r\n.ant-input-affix-wrapper::-webkit-input-placeholder,\r\n.ant-input-affix-wrapper::-moz-placeholder {\r\n  color: #ffffff !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.ant-input-affix-wrapper input::placeholder,\r\n.ant-input-affix-wrapper input::-webkit-input-placeholder,\r\n.ant-input-affix-wrapper input::-moz-placeholder {\r\n  color: #ffffff !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.dark-form .ant-input::placeholder,\r\n.dark-form .ant-input::-webkit-input-placeholder,\r\n.dark-form .ant-input::-moz-placeholder {\r\n  color: #ffffff !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.dark-form .ant-input-affix-wrapper::placeholder,\r\n.dark-form .ant-input-affix-wrapper::-webkit-input-placeholder,\r\n.dark-form .ant-input-affix-wrapper::-moz-placeholder {\r\n  color: #ffffff !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.dark-form .ant-input-affix-wrapper input::placeholder,\r\n.dark-form .ant-input-affix-wrapper input::-webkit-input-placeholder,\r\n.dark-form .ant-input-affix-wrapper input::-moz-placeholder {\r\n  color: #ffffff !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n/* Modal 对话框暗黑主题 */\r\n.ant-modal {\r\n  background: #161b22 !important;\r\n}\r\n\r\n.ant-modal-header {\r\n  background: #161b22 !important;\r\n  border-bottom: 1px solid #30363d !important;\r\n}\r\n\r\n.ant-modal-title {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-modal-content {\r\n  background: #161b22 !important;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-modal-body {\r\n  background: #161b22 !important;\r\n  color: #ffffff !important;\r\n}\r\n\r\n/* 强制覆盖 Modal 文字颜色 */\r\n.ant-modal-confirm-content {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-modal-confirm-title {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-modal-confirm-body {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-modal-confirm .ant-modal-body {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-modal-confirm .ant-modal-title {\r\n  color: #ffffff !important;\r\n}\r\n\r\n/* 使用更高优先级的选择器 */\r\ndiv.ant-modal-confirm-content {\r\n  color: #ffffff !important;\r\n}\r\n\r\ndiv.ant-modal-confirm-title {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-modal-footer {\r\n  background: #161b22 !important;\r\n  border-top: 1px solid #30363d !important;\r\n}\r\n\r\n.ant-modal-confirm-btns .ant-btn {\r\n  background: #21262d !important;\r\n  border: 1px solid #30363d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-modal-confirm-btns .ant-btn:hover {\r\n  background: #30363d !important;\r\n  border: 1px solid #58a6ff !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-modal-confirm-btns .ant-btn-danger {\r\n  background: #da3633 !important;\r\n  border: 1px solid #da3633 !important;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.ant-modal-confirm-btns .ant-btn-danger:hover {\r\n  background: #f85149 !important;\r\n  border: 1px solid #f85149 !important;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.dark-input.ant-input {\r\n  background: #21262d !important;\r\n  border: 1px solid #30363d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.dark-input.ant-input:hover,\r\n.dark-input.ant-input:focus {\r\n  background: #21262d !important;\r\n  border: 1px solid #58a6ff !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n/* 管理员登录页面特定样式 */\r\n.ant-form-item-control-input .dark-input {\r\n  background: #21262d !important;\r\n  border: 1px solid #30363d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-input-affix-wrapper {\r\n  background: #21262d !important;\r\n  border: 1px solid #30363d !important;\r\n}\r\n\r\n.ant-input-affix-wrapper:hover,\r\n.ant-input-affix-wrapper:focus {\r\n  background: #21262d !important;\r\n  border: 1px solid #58a6ff !important;\r\n}\r\n\r\n.ant-input-affix-wrapper input {\r\n  background: #21262d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.ant-input-affix-wrapper .ant-input {\r\n  background: #21262d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n/* 管理员登录页面强制样式 */\r\n.dark-form .ant-input-affix-wrapper {\r\n  background: #21262d !important;\r\n  border: 1px solid #30363d !important;\r\n}\r\n\r\n.dark-form .ant-input-affix-wrapper:hover,\r\n.dark-form .ant-input-affix-wrapper:focus,\r\n.dark-form .ant-input-affix-wrapper-focused {\r\n  background: #21262d !important;\r\n  border: 1px solid #58a6ff !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.dark-form .ant-input {\r\n  background: #21262d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.dark-form .ant-input:hover,\r\n.dark-form .ant-input:focus {\r\n  background: #21262d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n\r\n.dark-form .ant-input-password input {\r\n  background: #21262d !important;\r\n  color: #e6edf3 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
